/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ContentSharing32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.068 6H10.4C9.075 6 8 7.033 8 8.307v15.386C8 24.967 9.075 26 10.4 26h11.2c1.324 0 2.4-1.033 2.4-2.307v-11.99a.75.75 0 00-.234-.543l-5.132-4.934A.816.816 0 0018.068 6zm-.618 13.23c-.201.184-.368.27-.574.27a.484.484 0 01-.501-.5v-1.374h-.22c-1.538 0-2.502.261-3.187 1.547-.146.27-.334.327-.522.327-.236 0-.446-.224-.446-.628 0-2.993 1.281-4.996 4.154-4.997h.221v-1.35c0-.289.21-.525.51-.525.201 0 .342.086.565.297l3.09 3.002c.159.15.21.31.21.451a.601.601 0 01-.21.448l-3.09 3.031z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default ContentSharing32;
